enum AccountingSystem {
	sevenNormal = "2007企业会计准则",
	thirteenRule = "2013小企业会计准则",
	npo = "民间非营利组织会计制度",
	nineteenRule = "2019企业会计准则",
	rural = "村集体经济组织会计制度"
}
export default AccountingSystem;